var exports = {
  "S": "x43aef4ae--bc6007--image",
  "w": "x43aef4ae--bc6007--image-icon",
};

module.exports = exports;
